import React from 'react';
import { connect } from 'react-redux';

import BrandItems from '../common/BrandItems';
import CategoryItems from '../common/CategoryItems';
import HeaderStocksNavigation from '../HeaderStocksNavigation';

class NewStockLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <HeaderStocksNavigation salonId={this.props.salonId} history={this.props.history} PageTitle="New Stock" />

        <div className="stock-settings-layout">
          <div className="banner default full-width">
            <div style={{ width: '100%' }}>
              <div className="cfix relative">
                <span className="img-emoji-1" role="img" aria-labelledby="lamp">
                  💡
                </span>
                <div className="text">
                  <strong>Pro tip:</strong>
                  Assign products to categories and brands in the Stock Manager tab by ticking the box next to the
                  product which will open the category manager window.
                </div>
              </div>
            </div>
          </div>
          <CategoryItems title="Category" />
          <BrandItems title="Brand" />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    currentSalon: { id: salonId },
  } = state;
  return {
    salonId,
  };
}

export default connect(
  mapStateToProps,
  null,
)(NewStockLayout);
